var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid right_wrapper guard_css"},[_c('AddGuardrailHeader'),_c('AddGuardrailForm',{staticClass:"table_wrap no_footer pt-2 bold_arrow"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }